module.exports = __webpack_public_path__ + "img/step2.949de0a2.png";